import { Modal } from "@general-backoffice/core";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

// import { getRiskName } from "../../utils/risks";

interface BotStatusToggleModalProps {
  bot?: { disabled?: boolean | null } | null;
  close: () => void;
  toggle: () => void;
  isLoading?: boolean;
}

const BotStatusToggleModal = ({ bot, close, toggle, isLoading }: BotStatusToggleModalProps) => {
  const { t } = useTranslation("bots", { keyPrefix: "botStatusToggleModal" });

  //fix for the animation
  const [lastState, setLastState] = useState<boolean | undefined>();
  useEffect(() => {
    if (typeof bot?.disabled === "boolean") setLastState(bot?.disabled);
  }, [bot?.disabled]);

  return (
    <Modal.Simple
      color={lastState ? "success" : "danger"}
      isOpen={!!bot && typeof bot.disabled === "boolean"}
      isLoading={isLoading}
      toggleOpen={close}
      closeText={t("closeBtn")}
      buttons={[{ color: "white", children: t("submitBtn"), onClick: toggle }]}
    >
      <div className="py-3 text-center">
        <i className="fas fa-power-off ni-3x mb-4" />
        <p>
          <Trans
            t={t}
            i18nKey={lastState ? "turnOn" : "turnOff"}
            components={[<span key="0" className="font-weight-600 text-uppercase" />]}
          />
        </p>
        {/*<div className="h2 text-white font-weight-600">*/}
        {/*  {getRiskName(bot?.userConfig?.risk) || ""}*/}
        {/*</div>*/}
      </div>
    </Modal.Simple>
  );
};

export default BotStatusToggleModal;
